
import { Component, Prop, Vue } from 'vue-property-decorator'
import LazyComponent from '~/components/LazyComponent.vue'
import TheScrollTop from '~/components/footer/TheScrollTop.vue'

const TheFooterDynamic = () =>
  import('~/components/footer/TheFooterDynamic.vue')

@Component({
  components: { LazyComponent, TheFooterDynamic, TheScrollTop },
})
export default class TheHeaderInfoDynamic extends Vue {
  @Prop(String) shopId: string
}
